export enum Cookie {
    UserDeviceId = '_pr_udid'
}